import styled from 'styled-components'

import { ReactComponent as CrossIconUnstyled } from 'icons/cross-circle-24.svg'

export const Pill = styled.div`
  height: 30px;

  display: flex;
  align-items: center;
  padding: 0 12px;

  font-size: ${({ theme }) => theme.fontSizes.smaller};
  text-transform: uppercase;
  line-height: 1.4;

  border-radius: ${({ theme }) => theme.radii.medium};
  border: 1px solid ${({ theme }) => theme.colors.border[2]};
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};

  :not(:last-child) {
    margin-right: 8px;
  }
`

export const CrossIcon = styled(CrossIconUnstyled)`
  width: 18px;
  margin-left: 8px;
  color: ${({ theme }) => theme.colors.foreground.secondary[3]};
  cursor: pointer;
`
